import {
  FETCH_CHEMISTUSERDETAILS_SUCCESS_ACTION,
  FETCH_CHEMISTDETAILSVIEW_INIT_ACTION,
  FETCH_CHEMISTDETAILSVIEW_SUCCESS_ACTION,
  FETCH_OFFERS_INIT,
  FETCH_OFFERS_SUCCESS,
  FETCH_OFFERS_FAIL,
} from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_CHEMISTUSERDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        chemistuserDtlsList: action.payload.rows,
        chemistuserDtlsCount: action.payload.count,
      };
    case FETCH_CHEMISTDETAILSVIEW_SUCCESS_ACTION:
      return {
        ...state,
        chemistmainDtls: action.payload,
      };
    case FETCH_CHEMISTDETAILSVIEW_INIT_ACTION:
      return {
        ...state,
        chemistmainDtls: {},
      };
    case FETCH_OFFERS_INIT:
      return {
        ...state,
        chemistOfferDtls: null,
        chemistOfferDtlscount: 0,
      };

    case FETCH_OFFERS_SUCCESS:
      return {
        ...state,
        chemistOfferDtls: action.payload.rows,
        chemistOfferDtlsCount: action.payload.count,
      };
    case FETCH_OFFERS_FAIL:
      return {
        ...state,
        chemistOfferDtls: null,
        chemistOfferDtlsCount: 0,
      };

    default:
      return {
        ...state,
      };
  }
}
